var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8376 33.3067C52.1199 40.0489 48.2997 46.367 41.9783 50.0167C31.4758 56.0803 18.0463 52.4819 11.9827 41.9794L11.3369 40.8608M9.16097 28.6936C9.87862 21.9514 13.6988 15.6333 20.0202 11.9836C30.5227 5.91998 43.9522 9.51841 50.0159 20.0209L50.6617 21.1395M9.02405 46.6705L10.9152 39.6127L17.973 41.5039M44.0258 20.4963L51.0836 22.3874L52.9747 15.3296M30.9994 19.3751V31.0001L37.4577 34.8751",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.818c8518b1348cb95180a2d8c352e8b9.svg";
export { ForwardRef as ReactComponent };